import React from 'react';
import { useNavigate } from 'react-router-dom';
import useStore from '../../store/useStore';

/**
 * WishlistNavButton — header icon button with badge count.
 * Props: className (string)
 */
const WishlistNavButton = ({ className = '' }) => {
  const { wishlist_count, isAuthenticated, openAuthModal } = useStore();
  const navigate = useNavigate();

  const handleClick = () => {
    if (!isAuthenticated) {
      if (openAuthModal) openAuthModal();
      return;
    }
    navigate('/account/wishlist');
  };

  return (
    <button
      onClick={handleClick}
      aria-label="Wishlist"
      title={isAuthenticated ? 'My Wishlist' : 'Login to view wishlist'}
      className={`relative flex items-center justify-center rounded-xl bg-gray-50 text-gray-700 transition-all hover:bg-red-50 hover:text-red-500 ${className}`}
    >
      <svg
        className="h-full w-full"
        fill={wishlist_count > 0 && isAuthenticated ? 'currentColor' : 'none'}
        stroke="currentColor"
        strokeWidth={wishlist_count > 0 && isAuthenticated ? 0 : 2}
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
        />
      </svg>

      {wishlist_count > 0 && isAuthenticated && (
        <span className="absolute -right-1 -top-1 flex h-5 w-5 items-center justify-center rounded-full bg-red-500 text-xs font-bold text-white shadow-lg sm:h-6 sm:w-6 sm:text-sm">
          {wishlist_count > 99 ? '99+' : wishlist_count}
        </span>
      )}
    </button>
  );
};

export default WishlistNavButton;
